import Entity from '../entity'

export default class TerminalBizum extends Entity<number>{
    merchantCode: string;
    terminal: string;
   
}